import { Button, Stack } from '@mui/material';
import { CredentialResponse, GoogleLogin } from '@react-oauth/google';

import { DevFeatures } from 'common/src/types/enums/ProductFeatures.enum';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import useAuth from 'portal/src/auth/useAuth';

const API_URL = import.meta.env.VITE_API_URL;

const GoogleButton = () => {
  return (
    <Button
      variant="outlined"
      sx={{
        width: '24rem',
        height: '2.375rem',
        textTransform: 'none',
        borderColor: 'rgba(0, 0, 0, 0.23)',
      }}
      onClick={() => {
        window.location.href = `${API_URL}${API_BASE_PATHS.AUTH.WORKOS_REDIRECT_GOOGLE}`;
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
        >
          <title>Google</title>
          <path
            fill="#4285F4"
            d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.874 2.684-6.615Z"
          />
          <path
            fill="#34A853"
            d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18Z"
          />
          <path
            fill="#FBBC05"
            d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332Z"
          />
          <path
            fill="#EA4335"
            d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58Z"
          />
        </svg>
        <span>Sign in with Google</span>
      </Stack>
    </Button>
  );
};

const GoogleLoginButton = ({
  onSuccess,
  onError,
}: {
  onSuccess: (credentialResponse: CredentialResponse) => void;
  onError: () => void;
}) => {
  const { featureChecker } = useAuth();
  const workosLoginEnabled = featureChecker.devFeatureEnabled(
    DevFeatures.WorkOsLogin,
  );

  return workosLoginEnabled ? (
    <GoogleButton />
  ) : (
    <GoogleLogin
      logo_alignment="center"
      text="continue_with"
      width={384}
      onSuccess={onSuccess}
      onError={onError}
    />
  );
};

export default GoogleLoginButton;
